import React, { ComponentType, useContext } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NoAccess from '../Component/NoAccess';
import { GlobalContext } from '../utils/ContextProviders/GlobalContextProvider';
import Loader from '../Component/Loader';

interface PrivateRouteProps extends Omit<RouteProps, 'component'> {
  component: ComponentType<any>;
  acl: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const { userData } = useContext(GlobalContext);

  return userData?.user_id ? (
    userData?.role ? (
      <Route {...rest} render={props => <Component {...props} />} />
    ) : (
      <NoAccess />
    )
  ) : (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '25% auto',
        height: 200,
        width: 200
      }}
    >
      <Loader />
      <Typography>Loading...</Typography>
    </Box>
  );
};

export default PrivateRoute;
